var _jsxFileName = "/repo/packages/webassets/src/components/CookieBanner/index.js",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * TODO:
 * Is CookieBanner still being used anywhere? If not, remove it?
 */
import React, { useState, useEffect } from 'react';
import Cookie from 'js-cookie';
import PropTypes from 'prop-types';
import { T, t, defineMessages } from '@sm/intl';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Sheet } from '@wds/sheet';
import { Button } from '@wds/button';
import { WebAssetsThemeWrapper } from '../../theme';
var CONSENT_KEY = 'gdpr_consent';
var CONSENT_DENIED_KEY = 'gdpr_consent_denied';
var COPY = defineMessages({
  COOKIE_BANNER: {
    id: 'CookieBanner.cookiePolicy',
    defaultMessage:
    // eslint-disable-next-line no-multi-str
    'In order to give you the best experience, SurveyMonkey and our third party partners may use cookies\
    and similar technologies, for example, to analyze usage and optimize our sites and services, personalize content,\
    tailor and measure our marketing and to keep the site secure. Please visit our\
    <a href="/mp/legal/privacy-policy/">privacy policy</a> for more information and our\
    <a href="/mp/legal/cookies/">cookies policy</a> for a list of all cookies used.',
    description: '[Type: Label][Vis.: med] - Cookie Banner Message'
  },
  COOKIE_PREFERENCES: {
    id: 'CookieBanner.preferences',
    defaultMessage: '<a href="/mp/legal/cookies/">Clear or manage cookie preferences</a>.',
    description: '[Type: Label][Vis.: med] - Cookie Banner Preferences'
  },
  NO: {
    id: 'CookieBanner.decline',
    defaultMessage: 'DISAGREE',
    description: '[Type: Label][Vis.: med] - Cookie Banner Decline button'
  },
  AGREE: {
    id: 'CookieBanner.agree',
    defaultMessage: 'AGREE',
    description: '[Type: Label][Vis.: med] - Cookie Banner Agree button'
  }
});
var CookieBanner = function CookieBanner(_ref) {
  var GDPR = _ref.GDPR;
  var hasGDPRConsent = GDPR.hasGDPRConsent,
    hasExplictlyDenied = GDPR.hasExplictlyDenied;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState('gdpr_consent_denied'),
    _useState4 = _slicedToArray(_useState3, 2),
    consent = _useState4[0],
    setConsent = _useState4[1];
  useEffect(function () {
    if (!show) {
      MetricsTracker.track({
        name: USER_EVENTS.GDPR_ACTION,
        data: {
          actionType: USER_EVENTS.GDPR_ACTION,
          actionFlow: consent !== CONSENT_KEY ? 'denyConsent' : 'giveConsent'
        }
      });
    }
  }, [show, consent]);
  if (hasGDPRConsent || hasExplictlyDenied || !show) {
    return null;
  }

  /**
   * Agree to tracking cookie
   * @param {Object} e
   */
  var onAgree = function onAgree(e) {
    e.stopPropagation();
    Cookie.set(CONSENT_KEY, 'true', {
      expires: 365,
      secure: true
    });
    setConsent(CONSENT_KEY);
    setShow(!show);
  };

  /**
   * Deny tracking cookie
   */
  var onDeny = function onDeny() {
    Cookie.set(CONSENT_DENIED_KEY, 'true', {
      expires: 7,
      secure: true
    });
    setConsent(CONSENT_DENIED_KEY);
    setShow(!show);
  };
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Sheet, {
    placement: "bottom",
    onClose: onDeny,
    show: show,
    closeButtonLabel: t(COPY.NO),
    showCloseButton: true,
    "data-testid": "CookieBanner",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Box, {
    pt: "6",
    pb: "5",
    px: "7",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    variant: "body",
    color: "darkMuted",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.COOKIE_BANNER,
    html: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Box, {
    mb: 5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    color: "darkMuted",
    component: "div",
    variant: "body",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.COOKIE_PREFERENCES,
    html: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Box, {
    pb: "3",
    pt: "3",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onAgree,
    "data-testid": "CookieBanner__Agree",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.AGREE,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 15
    }
  }))))));
};
CookieBanner.propTypes = {
  GDPR: PropTypes.shape({
    hasGDPRConsent: PropTypes.bool,
    hasExplictlyDenied: PropTypes.bool
  }).isRequired
};
export default CookieBanner;
//# sourceMappingURL=index.js.map